import { WrapperButtonType } from '../../types/components'
import Button from '../Button'
import { ButtonText, ButtonWrapper } from './styles'

const WrapperButton = ({
	buttonClickHandler,
	isEnabled,
	btnText,
	isLoading = false,
	height,
	width,
}: WrapperButtonType) => {
	return (
		<ButtonWrapper>
			<Button
				isLoading={isLoading}
				onBtnClick={buttonClickHandler}
				isEnabled={isEnabled}
				height={height}
				width={width}
			>
				<ButtonText>{btnText}</ButtonText>
			</Button>
		</ButtonWrapper>
	)
}

export default WrapperButton
